import LandingSection from '@/components/landing/LandingSection'
import { UserCheck } from 'react-feather'
import Students from 'public/img/students.svg'
import Link from 'next/link'

export default function Learning() {
  return (
    <LandingSection
      title="Learning"
      description="Actively taking notes on videos can help you focus and
    better understand main concepts. It will help you better remember what you
    hear and see."
      canonical="/cases/learning"
    >
      <div className="bg-gray-50 flex flex-col center px-6 flex-1">
        <div className="mx-auto px-4 sm:px-6 md:max-w-7xl">
          <div className="my-10">
            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
              <div className="center mb-5 md:block md:mb-0">
                <Students
                  role="img"
                  aria-label="Student taking notes while learning from a video"
                />
              </div>

              <div className="flex justify-center flex-col mt-10 md:ml-10 md:mt-0">
                <div>
                  <span className="h-12 w-12 rounded-md center bg-primary">
                    <UserCheck className="h-6 w-6 text-white" />
                  </span>
                </div>
                <div className="mt-6">
                  <h1 className="text-4xl tracking-tight font-extrabold md:text-6xl xl:text-7xl text-gray-900">
                    Learning
                  </h1>
                  <p className="mt-4 text-xl text-gray-500">
                    Actively taking notes on videos can help you focus and
                    better understand main concepts. Good note-taking will
                    improve your active listening, comprehension of material,
                    and retention. It will help you better remember what you
                    hear and see.
                  </p>
                  <p className="mt-4 text-xl text-gray-500">
                    When you are taking notes, your body becomes active and it
                    helps you to avoid feelings of distractions or drowsiness.
                    Listening carefully and deciding what to comprise in notes
                    keeps your mind active and involved with what you hear.
                  </p>
                  <div className="mt-6">
                    <Link href="/signup">
                      <a className="inline-flex clickable-opacity px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary">
                        Get started
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LandingSection>
  )
}
